import { forwardRef } from 'react'

import * as S from './styles'

/** 14 fora, 7 dentro → stroke 3.5 centrado no raio 5.25 */
const SIZE = 14
const INNER = 7
const CENTER = SIZE / 2
const STROKE_WIDTH = (SIZE - INNER) / 2
const RADIUS = (SIZE - STROKE_WIDTH) / 2
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

/**
 * Anel de progresso SVG. Preenche em sentido horário a partir do topo
 * (`rotate(-90)` sem espelhar o círculo).
 *
 * `forwardRef` + espalhar `...rest`: o Tooltip do app, em modo
 * `interactiveTrigger`, clona o filho pra injetar `aria-describedby`.
 */
const Ring = forwardRef<
  SVGSVGElement,
  RingProps & JSX.IntrinsicElements['svg']
>(({ percentage, color, accessibleLabel, ...rest }, ref) => {
  const dashLength = (percentage / 100) * CIRCUMFERENCE
  const isDecorative = !accessibleLabel

  return (
    <S.Root
      ref={ref}
      width={SIZE}
      height={SIZE}
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      role={isDecorative ? undefined : 'img'}
      aria-label={accessibleLabel}
      aria-hidden={isDecorative || undefined}
      tabIndex={isDecorative ? undefined : 0}
      {...rest}
    >
      <circle
        className="track"
        cx={CENTER}
        cy={CENTER}
        r={RADIUS}
        fill="none"
        strokeWidth={STROKE_WIDTH}
      />
      <circle
        className="fill"
        cx={CENTER}
        cy={CENTER}
        r={RADIUS}
        fill="none"
        stroke={color}
        strokeWidth={STROKE_WIDTH}
        strokeLinecap="round"
        strokeDasharray={`${dashLength} ${CIRCUMFERENCE}`}
        transform={`rotate(-90 ${CENTER} ${CENTER})`}
      />
    </S.Root>
  )
})

Ring.displayName = 'Ring'

export default Ring
